import { render, staticRenderFns } from "./VaPagination.demo.vue?vue&type=template&id=353c067c&"
import script from "./VaPagination.demo.vue?vue&type=script&lang=js&"
export * from "./VaPagination.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports